import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import styles from './NavigationTabLink.module.scss';

function NavigationTabLink({ match, disabled, to = '#', ...otherProps }) {
  const classes = classNames(
    'body14',
    styles.tabLink,
    disabled && styles['tabLink--disabled'],
  );

  return (
    <NavLink
      disabled={disabled}
      className={({ isActive }) =>
        `${classes} ${isActive ? styles['tabLink--active'] : ''}`
      }
      to={to}
      {...otherProps}
    />
  );
}

export default memo(NavigationTabLink);
